import Axios from 'axios'
import { getPathName, retryRequest, getApiToken } from './helper';

const sendArrepentimiento = async (stringContacto, captchaToken) => {
  // const data = {
  //   data: stringContacto,
  //   g_recaptcha_response: captchaToken
  // }
  const data = {
    htmlBody: stringContacto
  };
  const headers = {
    'content-type': 'application/json',
    "Authorization": 'Bearer ' + await getApiToken()
  }

  const axiosPostRequest = async() => {
    return Axios.post(await getPathName() + "/SendMailFormularioArrepentimiento", data, {
      headers: headers
    });
  };

  try {
    const response = await retryRequest(axiosPostRequest);
    return response;
  } catch (error) {
    console.error('Fallo de hacer varios intentos: ' + error.message);
    return error;
  }
};



export default sendArrepentimiento;